/* ======================================================
   COPPER KETTLE — THEME JS
   Cart drawer (AJAX), mobile nav, product gallery,
   quantity selectors, scroll reveal, newsletter.
   ====================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- MOBILE NAV ---------- */
  var hamburger = document.querySelector('[data-mobile-nav-open]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-nav-close]');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---------- PRODUCT GALLERY ---------- */
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      var mainImg = gallery.querySelector('[data-product-main-img]');
      var newSrc = thumb.getAttribute('data-full-src');
      if (mainImg && newSrc) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 180);
      }
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---------- VARIANT OPTION PILLS ---------- */
  document.querySelectorAll('[data-option-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('[data-option-group]');
      if (group) {
        group.querySelectorAll('[data-option-pill]').forEach(function (p) { p.classList.remove('selected'); });
      }
      pill.classList.add('selected');
      var hiddenInput = pill.closest('[data-option-group]').querySelector('input[type="hidden"]');
      if (hiddenInput) hiddenInput.value = pill.getAttribute('data-value');
      updateVariantSelection();
    });
  });

  function updateVariantSelection() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var selectedOptions = [];
    form.querySelectorAll('[data-option-group] input[type="hidden"]').forEach(function (input) {
      selectedOptions.push(input.value);
    });
    var variants = window.__productVariants || [];
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
    var variantIdInput = form.querySelector('[data-variant-id-input]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');

    if (match) {
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- QUANTITY SELECTOR ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (sel) {
    var input = sel.querySelector('input');
    var minus = sel.querySelector('[data-qty-minus]');
    var plus = sel.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      input.value = v + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- ADD TO CART (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var formData = new FormData(form);
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          refreshCartDrawer();
          openCartDrawer();
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-add-text') || 'Add to Cart'; }
          }, 1800);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Error — Try Again'; }
        });
    });
  });

  /* ---------- CART DRAWER ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var cartOpenTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  var cartCloseTriggers = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartOpenTriggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer();
      openCartDrawer();
    });
  });
  cartCloseTriggers.forEach(function (t) { t.addEventListener('click', closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCountBubble(cart.item_count);
      });
  }

  function updateCartCountBubble(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-drawer-items]');
    var footerEl = document.querySelector('[data-cart-drawer-footer]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="font-family:var(--serif);font-style:italic;font-size:16px;color:var(--grey);text-align:center;padding:40px 0;">Your cart is empty.</p>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-product" style="margin-bottom:20px;align-items:flex-start;">' +
        '<img src="' + item.image + '&width=160" alt="' + item.product_title + '">' +
        '<div style="flex:1;">' +
          '<div class="cart-product-name">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="cart-product-variant">' + item.variant_title + '</div>' : '') +
          '<div style="font-size:12px;color:var(--grey);margin-top:6px;">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + '</div>' +
          '<a href="/cart/change?line=' + item.key + '&quantity=0" class="cart-remove" data-cart-remove data-line-key="' + item.key + '">Remove</a>' +
        '</div>' +
      '</div>';
    });
    itemsEl.innerHTML = html;

    var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var key = link.getAttribute('data-line-key');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            renderCartDrawer(cart);
            updateCartCountBubble(cart.item_count);
          });
      });
    });
  }

  /* ---------- CART PAGE QUANTITY UPDATES ---------- */
  document.querySelectorAll('[data-cart-page-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value || '1', 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- FAQ ACCORDION (native <details>, no extra JS needed) ---------- */

  /* ---------- NEWSLETTER FORM FEEDBACK ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var success = form.querySelector('[data-newsletter-success]');
      if (success) {
        setTimeout(function () { success.classList.add('show'); }, 300);
      }
    });
  });

});
